export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCD0I-7lJbX2JkwedVuz87Fil4BlmBcg7s",
    authDomain: "aoa-labs.firebaseapp.com",
    projectId: "aoa-labs",
    storageBucket: "aoa-labs.appspot.com",
    messagingSenderId: "1078604004638",
    appId: "1:1078604004638:web:0bc4f6d64cf6fdffde9d0f",
    measurementId: "G-HMG4H8ZCV8"
  },
  baseUrl: 'https://billy-backend-dev-new-1078604004638.southamerica-east1.run.app',
  authToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiYWJ1ZGFiYSIsImlhdCI6MTY3NTExNTE2OH0.Xcxcz7preBKTU5ROnk8nPO_Mo2WVLStd1AMXyUKZPjY',
};
